export default __webpack_public_path__ + "static/SohneIkon-Buch-f73fcfd673e115ec3b889c7492025464.woff2";